<script lang="ts">
  import filters from '../lib/stores/filters'
  import type { Filter } from '../global'

  export let areas: Array<Filter.Locations>
</script>

<div>
  {#each areas as { region, cities } (`place-${region.key}`)}
    <div class="py-1">
      <div class="mb-2 border-b border-gray-200">
        <label
          class="block cursor-pointer py-2 text-center font-bold text-skin-primary"
          class:bg-gray-300={$filters.place === -region.key}
        >
          <input
            type="radio"
            bind:group={$filters.place}
            name="mesto"
            value={-region.key}
            class="hidden"
          />
          {@html region.name}
        </label>
      </div>
      <ul class="grid gap-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-1.5">
        {#each cities as city (`${city.seostring}-${city.id}`)}
          <li>
            <label
              class="block cursor-pointer p-0.5"
              class:font-bold={city.isTop}
              class:bg-gray-300={$filters.place === city.seostring}
            >
              <input
                type="radio"
                bind:group={$filters.place}
                name="mesto"
                value={city.seostring}
                class="hidden"
              />
              <span>{@html city.name}</span>
            </label>
          </li>
        {/each}
      </ul>
    </div>
  {/each}
</div>
